import { Example } from '@/types/Example';
import { useSlicedNotes } from '@/utils/hooks/use-sliced-notes';
import { useMemo } from 'react';
import CommandCatalogue from './CommandCatalogue';
import useZStore from '@/utils/useZStore';
import { Button } from './ui/button';
import Link from 'next/link';

interface BookmarksCheatsheetProps {
  examples: Example[];
  showAsGrid: boolean;
  showDifficulty: boolean;
  editable: boolean;
}

const BookmarksCheatsheet = (props: BookmarksCheatsheetProps) => {
  const { examples, ...rest } = props;
  const bookmarkedNotesIds = useSlicedNotes('bookmarked');
  const initialized = useZStore((state) => state.initialized);

  const bookmarkedExamples = useMemo(() => {
    return examples.filter((cheat) => bookmarkedNotesIds.includes(cheat.id));
  }, [examples, bookmarkedNotesIds]);

  if (!initialized) {
    return null;
  }

  if (bookmarkedExamples.length === 0) {
    return (
      <div className="w-full max-w-5xl print:max-w-full">
        <div className="flex flex-col items-center justify-center gap-4 p-4 pt-8 sm:p-0 sm:pt-16 print:p-0">
          <p>{`You don't have any bookmarked commands.`}</p>
          <Button asChild>
            <Link href="/cheatsheet?filter=all">Go to the complete list</Link>
          </Button>
          <p>{`And configure your custom Git cheatsheet.`}</p>
        </div>
      </div>
    );
  }

  return <CommandCatalogue cheats={bookmarkedExamples} {...rest} />;
};

export default BookmarksCheatsheet;
